<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <div class="list-box" style="flex: 1; overflow: hidden">
      <ul class="list-search">
        <el-space wrap style="flex: 1">
          <el-input
            v-model="state.params.keywords"
            style="width: 200px"
            placeholder="姓名、手机号、证件号"
            clearable
            @clear="
              delete state.params.keywords;
              onLoad();
            "
            @paste.enter="$onKeywordsPaste($event, state.params)"
          ></el-input>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
        <el-button
          type="primary"
          :icon="Upload"
          link
          @click="onExport"
          size="large"
          >导出
        </el-button>
      </ul>
      <div
        class="table-container"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
      >
        <table
          cellpadding="20"
          cellspacing="0"
          v-if="Array.isArray(state.tableData)"
        >
          <thead>
            <tr>
              <th style="white-space: nowrap">序号</th>
              <th style="white-space: nowrap; text-align: center">
                所属工资表
              </th>
              <th style="white-space: nowrap">算税单号</th>
              <template
                v-for="(item, index) in state.templateSortFields"
                :key="item"
              >
                <th style="white-space: nowrap" v-if="index > 1">
                  {{ item.name }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in state.tableData" :key="row">
              <td style="white-space: nowrap">{{ rowIndex + 1 }}</td>
              <td style="white-space: nowrap">{{ state.payroll?.name }}</td>
              <td style="white-space: nowrap">{{ state.calcTax?.order_id }}</td>
              <template
                v-for="(item, index) in state.templateSortFields"
                :key="item"
              >
                <template v-if="index > 1">
                  <td
                    v-if="item.field == 'payroll.name'"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ state.payroll?.name }}
                  </td>
                  <td
                    v-if="item.field == 'calc_tax.name'"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ state.payroll?.name }}
                  </td>
                  <td v-else style="white-space: nowrap; text-align: center">
                    {{
                      item.field
                        .split(".")
                        .reduce(
                          (acc, key) =>
                            acc && acc[key] !== undefined ? acc[key] : "-",
                          row
                        )
                    }}
                  </td>
                </template>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新专项附加扣除"
        @close="state.showAgent = false"
      >
        <c_Agent
          :skssq="state.params.skssq"
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_EssentialLog></c_EssentialLog>
    </el-drawer>
  </div>
</template>

<script>
import { onMounted, reactive, ref, h, watch } from "vue";
import { calctax_accounting, calctax_accounting_export } from "@/http/calctax";
import { priceFormat } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

class InitFormData {
  params = {};
}
export default {
  props: {
    id: Number,
    keywords: String,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      statistics: [],
      templateSortFields: [],
    });
    onMounted(() => {
      state.params.calc_tax_id = props.id;
      onLoad();
    });

    watch(
      () => props.keywords,
      (value) => {
        if (value) state.params.keywords = value;
      }
    );

    const onLoad = () => {
      delete state.tableData;

      calctax_accounting(state.params).then((res) => {
        if (res.status == 200) {
          const { list, payroll, sortFields, calcTax } = res.data.data;
          state.tableData = list;
          state.templateSortFields = sortFields;
          state.payroll = payroll;
          state.calcTax = calcTax;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const getSummaries = () => {
      let res = [];
      res[0] = h("div", { style: { whiteSpace: "nowrap" } }, ["合计"]);
      const keys = Object.keys(state.statistics);
      keys.forEach((key) => {
        const index = state.templateSortFields.findIndex((w) => w.field == key);
        if (index > -1) res[index + 5] = priceFormat(state.statistics[key]);
      });

      return res;
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      calctax_accounting_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      getSummaries,
      onExport,
    };
  },
};
</script>
<style lang="less" scoped>
.table-container::-webkit-scrollbar {
  width: 15px;
  height: 15px;
}

.table-container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #61b0f5;
}

.table-container::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: transparent;
}

.table-container {
  min-height: 100px;
  overflow-y: auto; /* 垂直滚动条 */
  display: block; /* 或者使用 overflow: scroll; */
  border: 1px solid #ebeef5;
  font-size: 14px;
  color: #606266;

  table {
    width: 100%; /* 或者具体的宽度 */
    border-collapse: separate; /* 合并边框 */
  }

  thead th {
    position: sticky; /* 使表头固定 */
    top: 0; /* 固定在顶部 */
    z-index: 1; /* 确保表头在其他内容之上 */
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
    color: #909399;
  }

  th,
  td {
    position: -webkit-sticky; /* Safari */
    position: sticky;
  }

  /* 固定第一列 */
  thead th:first-child {
    top: 0;
    left: 0;
    z-index: 10; /* 确保在最上层 */
    background-color: #fff;
  }

  tbody td:first-child {
    left: 0;
    z-index: 2; /* 确保在最上层 */
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
  }

  tbody td {
    border-bottom: 1px solid #ebeef5;
  }
}
</style>
